import { ClipLoader } from 'react-spinners'
import { SOCKET_URL } from '../../../../core/constants/urls'
import { formatNumber } from '../../../../core/utils/common'
import Text from '../../../../core/utils/Text'
import BoundBox from '../available-coins/details/BoundBox'
import { useState } from 'react'

const AccountingCard = ({ item, idx, type, onEdit, onRemove }) => {
	const [fullscreen, setFullscreen] = useState(false)
	const openFullscreen = () => setFullscreen(true)
	const closeFullscreen = () => setFullscreen(false)

	return (
		<>
			{fullscreen ? (
				<div
					onClick={closeFullscreen}
					className={
						'fixed left-0 top-0 w-screen h-screen backdrop-blur-sm z-[10] flex items-center justify-center'
					}
				>
					<Content item={item} fullscreen />
				</div>
			) : null}
			<Content
				item={item}
				onEdit={onEdit}
				onRemove={onRemove}
				idx={idx}
				openFullscreen={openFullscreen}
				type={type}
			/>
		</>
	)
}

const Content = ({ item, fullscreen, onEdit, onRemove, idx, openFullscreen, type }) => {
	const getRandomBg = (idx) => {
		const bgs = [
			'bg-green-500',
			'bg-blue-500',
			'bg-purple-500',
			'bg-orange-500',
			'bg-red-500',
			'bg-cyan-500',
			'bg-yellow-500',
		]

		return bgs[idx % 7]
	}

	const typeColors = {
		string: 'bg-green-500/30',
		number: 'bg-blue-500/30',
		date: 'bg-yellow-500/30',
		boolean: 'bg-cyan-500/30',
	}

	return (
		<div
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
			}}
			className={`${
				fullscreen ? 'w-[600px] border-[1px] border-slate-500/20' : 'w-[360px]'
			} rounded-md opacity-100 dark:bg-cardBg bg-gray-100`}
		>
			<div
				className={`w-full h-[32px] ${getRandomBg(idx)} bg-opacity-30 rounded-md flex justify-end`}
			/>

			<div className={'flex flex-col gap-2 p-4'}>
				{item ? (
					<>
						<div className={'flex items-center justify-center gap-2'}>
							<img
								src={
									item.currency === 'irt'
										? require('../../../../assets/images/tooman.png')
										: SOCKET_URL + `assets/icon/${item.currency}.png`
								}
								width='32px'
								alt=' '
							/>
							<span className={'dark:text-white mt-2'}>{item.currency.toUpperCase()}</span>
						</div>

						<div className={'text-center'}>
							<span className={'dark:text-white text-xl'}>{item.name}</span>
						</div>

						<div className={'bg-slate-500 bg-opacity-10 h-[1px]'} />
						<BoundBox min={item.min} max={item.max} currency={item.currency} />

						<div
							className={
								'grid grid-cols-12 items-center gap-2 p-3 rounded-md dark:bg-primaryBg text-[0.7rem]'
							}
						>
							<DetailRow prefix={'fee-factor'} suffix={`${formatNumber(item.feeFactor)} %`} />

							<DetailRow
								prefix={'fee-min'}
								suffix={`${formatNumber(item.feeMin)} ${item.currency.toUpperCase()}`}
							/>

							<DetailRow
								prefix={'fee-max'}
								suffix={`${formatNumber(item.feeMax)} ${item.currency.toUpperCase()}`}
							/>
						</div>

						<div className={'bg-slate-500 bg-opacity-10 h-[1px]'} />

						{fullscreen ? (
							<div className={'grid grid-cols-2 gap-3'}>
								{item?.fields.map((f) => {
									return (
										<div key={f.id} className={'rounded-md dark:bg-primaryBg text-[0.75rem]'}>
											<div
												className={`rounded-t-md ${
													typeColors[f.type]
												} h-[26px] w-full flex items-center px-3`}
											>
												<span>{f.type}</span>
											</div>
											<div className='flex flex-col p-2'>
												<div className={'flex flex-col'}>
													<Text tid={'name-col'} />
													<span>{f.name}</span>
												</div>
												<div className={'h-[1px] w-full my-2 bg-slate-500/20'} />
												<div className={'flex flex-col'}>
													<Text tid={'description-col'} />
													<span>{f.description}</span>
												</div>
											</div>
										</div>
									)
								})}
							</div>
						) : null}
					</>
				) : (
					<div className={'h-[300px]'}>
						<div className={'flex h-full items-center justify-center'}>
							<ClipLoader size={24} color={'#ffc800'} />
						</div>
					</div>
				)}

				{!fullscreen ? (
					<>
						<div
							className={`
                        rounded-md h-[36px] mt-3 text-sm border-[1px] border-blue-500 border-opacity-40 
                        flex items-center justify-center hover:bg-blue-500 hover:bg-opacity-70 hover:text-gray-800 transition cursor-pointer
                        `}
							onClick={openFullscreen}
						>
							<Text tid={'show-full-details'} />
						</div>
						<div
							className={`
            rounded-md h-[36px] text-sm border-[1px] border-active border-opacity-40 
            flex items-center justify-center hover:bg-active hover:bg-opacity-70 hover:text-gray-800 transition cursor-pointer
            `}
							onClick={() => onEdit(item, idx, type)}
						>
							<Text tid={'edit-accounting'} />
						</div>

						<div
							className={`
            rounded-md h-[36px] text-sm border-[1px] border-red-500 border-opacity-40 
            flex items-center justify-center hover:bg-red-500 hover:bg-opacity-70 hover:text-gray-800 transition cursor-pointer
            `}
							onClick={() => onRemove(item, idx, type)}
						>
							<Text tid={'remove-accounting'} />
						</div>
					</>
				) : null}
			</div>
		</div>
	)
}

const DetailRow = ({ prefix, suffix }) => {
	return (
		<>
			<Text tid={prefix} className={'text-gray-400 col-span-5'} />
			<div className={'border-[1px] border-dashed border-gray-500 border-opacity-20 col-span-3'} />
			<span dir={'ltr'} className={'col-span-4'}>
				{suffix}
			</span>
		</>
	)
}

export default AccountingCard
